

export class Constants {
    static baseUrl = 'https://ngapi.sarvadhnya.com/api';
    static books = this.baseUrl + '/books';
    static pothis = this.baseUrl + '/pothis';
    static charitra = this.baseUrl + '/charitra';
    static panchakrushna = this.baseUrl + '/Panchakrushna/';
    static smruti = this.baseUrl + '/smruti/';
    static stotra = this.baseUrl + '/stotra/';
    static songs = this.baseUrl + '/songs';

    static apps = this.baseUrl + '/apps';
    static arti = this.baseUrl + '/arti/';
    static gallery = this.baseUrl + '/gallery';
    static sthan = this.baseUrl + '/sthan/';
    static sutra = this.baseUrl + '/sutra/';
    static drustant = this.baseUrl + '/drustant/';
    static videos = this.baseUrl + '/videos';
    static visitors = this.baseUrl + '/Visitors';
    static allsthan = this.baseUrl + '/Sthan/all';
}

export class InitScripts {
    loadScripts() {
        this.loadScript("../assets/vendor/purecounter/purecounter_vanilla.js");
        this.loadScript("../assets/vendor/aos/aos.js");
        this.loadScript("../assets/vendor/bootstrap/js/bootstrap.bundle.min.js");
        this.loadScript("../assets/vendor/swiper/swiper-bundle.min.js");
        this.loadScript("../assets/js/main.js");
    }

    private loadScript(url: string) {
        var scripts = document.getElementsByTagName('script');
        for (var i = scripts.length; i--;) {
            if (scripts[i].src.endsWith(url.replace("..", ""))) {
                scripts[i].remove();
                break;
            }
        }
        const body = <HTMLDivElement>document.body;
        const script = document.createElement('script');
        script.innerHTML = '';
        script.src = url;
        script.async = false;
        script.defer = true;
        body.appendChild(script);
    }

    // loadMeta() {
    //     var scripts = document.getElementsByTagName('meta');
    //     for (var i = scripts.length; i--;) {
    //         if (scripts[i].httpEquiv == "Permissions-Policy") {
    //             scripts[i].remove();
    //             break;
    //         }
    //     }
    //     const head = <HTMLDivElement>document.head;
    //     const script = document.createElement('meta');
    //     script.httpEquiv = "Permissions-Policy";
    //     script.content = "interest-cohort=()";
    //     head.appendChild(script);
    // }    
}
